import PricingListItem from '../../../../Domain/PricingListItem';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import PricingService from '../../../../Services/PricingService';

// Drives the GeneralEditWizzardBaseFigma bulk "Pricing Multiple Update" action panel. Each field
// carries isCheckBoxEnabled so the user opts a field in/out of the multi-update (the wizard wires
// getCheckBoxFieldsObject / changeOfEditedMultipItem through to InputWithClear, and MultiplePost
// strips fields whose <field>Status is false). >6 fields keep it in the full-screen wizard.
class PricingMultipleEditWindowDescription {
  static titleForCreate = 'Pricing Multiple Update';
  static titleForEdit = 'Pricing Multiple Update';
  static finishButtonLabel = 'Save';
  static itemType = PricingListItem;
  static serviceFunction = (edited) => PricingService.MultiplePost(edited);
  static messageOnSuccess = 'Pricing has been updated!';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'NumEvalsPerCycle',
          label: 'No. Evals / Cycle',
          className: 'col-12',
          type: InputTypesEnum.InputWithCheckBox,
          validityChecker: ValidityHelper.emptyValidityChecker,
          disabled: (editedItem) => editedItem.EditingApprovedPricings,
          isCheckBoxEnabled: true,
        },

        {
          fieldName: 'MarkUpPct',
          label: 'Mark-Up %',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.emptyValidityChecker,
          disabled: (editedItem) => editedItem.EditingApprovedPricings,
          isCheckBoxEnabled: true,
          //roleKey: 'manual_owningofficefee_inputfield',
        },

        {
          fieldName: 'StatusCode',
          label: 'Status',
          className: 'col-12',
          type: InputTypesEnum.PricingStatusLookupItemSelect,
          validityChecker: ValidityHelper.emptyValidityChecker,
          isCheckBoxEnabled: true,
        },

        {
          fieldName: 'OfficeId',
          label: 'Fieldwork Office',
          className: 'col-12',
          type: InputTypesEnum.OfficeSelect,
          validityChecker: ValidityHelper.emptyValidityChecker,
          disabled: (editedItem) => editedItem.EditingApprovedPricings,
          isCheckBoxEnabled: true,
        },

        {
          fieldName: 'CurrencyId',
          label: 'Currency',
          className: 'col-12',
          type: InputTypesEnum.ActiveCurrencySelect,
          validityChecker: ValidityHelper.emptyValidityChecker,
          disabled: (editedItem) => editedItem.EditingApprovedPricings,
          isCheckBoxEnabled: true,
        },

        {
          fieldName: 'RoundFee',
          label: 'Round Owning Office Fee',
          className: 'col-12',
          type: InputTypesEnum.Bool,
          validityChecker: ValidityHelper.emptyValidityChecker,
          disabled: (editedItem) => editedItem.EditingApprovedPricings,
          isCheckBoxEnabled: true,
        },

        {
          fieldName: 'MysteryShoppingPlatformPricingId',
          label: 'Mystery Shopping Platform Pricing',
          className: 'col-12',
          type: InputTypesEnum.MysteryShoppingPlatformPricingLookupSelect,
          validityChecker: ValidityHelper.emptyValidityChecker,
          disabled: (item) => item.Pricings.some((x) => x.StatusCode.toString() !== '1'),
          isCheckBoxEnabled: true,
        },

        {
          fieldName: 'CallRecordingCostId',
          label: 'Call Recording Cost',
          className: 'col-12',
          type: InputTypesEnum.CallRecordingCostLookupSelect,
          validityChecker: ValidityHelper.emptyValidityChecker,
          disabled: (item) => item.Pricings.some((x) => x.StatusCode.toString() !== '1'),
          isCheckBoxEnabled: true,
        },

        {
          fieldName: 'CsatcostId',
          label: 'CSAT Cost',
          className: 'col-12',
          type: InputTypesEnum.CsatCostLookupSelect,
          validityChecker: ValidityHelper.emptyValidityChecker,
          disabled: (item) => item.Pricings.some((x) => x.StatusCode.toString() !== '1'),
          isCheckBoxEnabled: true,
        },

        {
          fieldName: 'IvrcostId',
          label: 'IVR Cost',
          className: 'col-12',
          type: InputTypesEnum.IvrCostLookupSelect,
          validityChecker: ValidityHelper.emptyValidityChecker,
          disabled: (item) => item.Pricings.some((x) => x.StatusCode.toString() !== '1'),
          isCheckBoxEnabled: true,
        },
      ],
    },
  ];
}

export default PricingMultipleEditWindowDescription;
